import React from 'react';
import { useTranslation } from 'react-i18next';
import { StandardModal, ModalBody, ModalFooter } from '../../Components/Fundamentals/Modal/StandardModal';
import useModal from '../../Hooks/useModal';

function ConfirmModal({ confirmTitle, confirmTextElement, onConfirmed, onCancel, buttonTexts }) {
    const { t } = useTranslation();
    const { closeModal } = useModal();

    const handleConfirm = () => {
        if (onConfirmed) onConfirmed();
        closeModal();
    };

    const handleCancel = () => {
        if (onCancel) onCancel();
        closeModal();
    };

    const defaultButtonTexts = buttonTexts || [t('common.confirm'), t('common.cancel')];

    return (
        <StandardModal title={confirmTitle} onClose={handleCancel}>
            <ModalBody>
                {confirmTextElement ?? <p>{t('confirmmodal.confirmaction')}</p>}
            </ModalBody>
            <ModalFooter>
                <div className="w-100 d-flex justify-content-end gap-8">
                    <button className="btn btn-primary btn-sm" onClick={handleConfirm}>
                        {defaultButtonTexts[0]}
                    </button>
                    <button className="btn btn-default btn-sm" onClick={handleCancel}>
                        {defaultButtonTexts[1]}
                    </button>
                </div>
            </ModalFooter>
        </StandardModal>
    );
}

export default ConfirmModal;
